import React, { useEffect, useState } from "react";
import { Button, Col, Divider, Form, Input, Layout, Row, Typography, Select, Space, Modal, Checkbox, Collapse, Table, Tag, InputNumber, notification } from 'antd';
import { PlusOutlined, FilterOutlined, CaretLeftOutlined, CaretRightOutlined } from '@ant-design/icons';
import { useNavigate, useParams } from "react-router-dom";
import { inject, observer } from 'mobx-react'
import Swal from "sweetalert2";

import "./style.scss";
import { cloneDeep } from "lodash";                           

const { Content } = Layout;
const { Title, Text } = Typography;
const { TextArea } = Input;
const { Panel } = Collapse;

const AddEventAyuda = ({ userStore, voterStore, eventStore }) => {

    const [form] = Form.useForm();
    const [formEdit] = Form.useForm();
    const navigate = useNavigate();

    let { id } = useParams();

    const [searchName, setSearchName] = useState();
    const [searchStreet, setSearchStreet] = useState();
    const [searchAddress, setSearchAddress] = useState();
    const [searchGender, setSearchGender] = useState();
    const [searchPWD, setSearchPWD] = useState(false);

    const [hasGender, setHasGender] = useState(false);
    const [hasStreet, setHasStreet] = useState(false);
    const [hasAddress, setHasAddress] = useState(false);
    const [hasPWD, setHasPWD] = useState(false);

    const [selectedVoter, setSelectedVoter] = useState()
    const [topUpSelectedVoter, setTopUpSelectedVoter] = useState([]);

    const [isOpenForm, setIsOpenForm] = useState(false);
    const [isOpenEditForm, setIsOpenEditForm] = useState(false);

    const [total, setTotal] = useState(0);

    useEffect(() => {
        const newTotal = topUpSelectedVoter.reduce((sum, item) => sum + parseFloat(item.amount), 0);
        setTotal(newTotal);
    }, [topUpSelectedVoter]);

    useEffect(() => {
        const storedData = JSON.parse(localStorage.getItem(`ayudacash_${id}`)) || [];

        setTopUpSelectedVoter(storedData);

        if(storedData.length > 0){
            storedData.forEach((ayuda) => {
                setTotal(total + parseInt(ayuda.amount))
            })
        }

        if(selectedVoter) {
            form.setFieldsValue(selectedVoter)
        }

    }, [selectedVoter])

    useEffect(() => {

        const login_user = JSON.parse(localStorage.getItem(`dXNlclN0b3Jl`)) || [];

        voterStore.page = 1;
        voterStore.hasMore = false;
        voterStore.perPage = 5;
        voterStore.fetchVoters();
        if (id) {
            eventStore.fetchEventByID(id);
        }

        if (login_user.userID) {
            userStore.fetchUserByID(login_user.userID);
        }

    }, [])
    
    const handlePrevPage = () => {
        voterStore.page = voterStore.page - 1;
        voterStore.fetchVoters();
    };
    
    const handleNextPage = () => {
        voterStore.page = voterStore.page + 1;
        voterStore.fetchVoters();
    };

    const handleSearchVoter = () => {
        if (!searchName && !searchStreet && !searchAddress && !searchGender && !searchPWD) {
          notification.error({
            top: 120,
            message: 'Error!',
            description: 'Please provide proper data for accurate results.'
          });
          return;
        } else if(searchName == ""){
            notification.error({
              top: 120,
              message: 'Error!',
              description: 'Please provide a Voter Name'
            });
            return;
        } else{
    
          const searchParams = {};
          if (searchName) searchParams.name = searchName;
          if (searchStreet) searchParams.street = searchStreet;
          if (searchAddress) searchParams.address = searchAddress;
          if (searchGender) searchParams.gender = searchGender;
          if (searchPWD) searchParams.pwd = searchPWD;
    
          voterStore.searchVotersMultipleData(searchParams);
        }
    };
    

    const formatNumber = (formatnumber) => {
        return new Intl.NumberFormat("en-US", {
            style: "decimal",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(formatnumber);
    };

    const columns = [
        {
            title: 'Name',
            key: 'FullName+ID',
            dataIndex: 'FullName',
            responsive: ['lg', 'xl', 'md'],
            render: (FullName) => (
              <Text default>{FullName}</Text>
            )
          },
          {
            title: 'Street',
            key: 'Street+ID',
            dataIndex: 'Street',
            responsive: ['lg', 'xl', 'md'],
            render: (Street) => (
              <Text default>{Street}</Text>
            )
          },
          {
            title: 'Address',
            key: 'Address+ID',
            dataIndex: 'Address',
            responsive: ['lg', 'xl', 'md'],
            render: (Address) => (
              <Text default>{Address}</Text>
            )
          },
          {
            title: 'Gender',
            key: 'Sex+ID',
            dataIndex: 'Sex',
            responsive: ['lg', 'xl', 'md'],
            width: '15%',
            render: (Sex) => (
              <Text default>{Sex}</Text>
            )
          },
        {
          title: 'Action',
          dataIndex: 'action',
          key: 'action',
          render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost
                    onClick={() => {
                    
                        // Check if the team leader is already selected
                        const isAlreadySelected = topUpSelectedVoter.some(item => item.ID === record.ID);

                        if (isAlreadySelected) {
                            // If the team leader is already selected, show an error notification
                            notification.warning({
                                message: 'Warning!',
                                description: `${record.FullName} is already selected.`,
                                top: 120,
                            });
                        } else {
                            setSelectedVoter(null); // Reset before selecting
                            form.resetFields(); // Reset form fields

                            // If not selected, proceed with selection
                            setSelectedVoter(record);
                            setIsOpenForm(true);
                        }
                    }}
                >Select</Button>
            </Space>
          )
        },
    ];

    const columnsAyuda = [
        {
            title: 'Name',
            key: 'FullName+ID',
            dataIndex: 'FullName',
            responsive: ['lg', 'xl', 'md'],
            render: (FullName) => (
            <Text default>{FullName}</Text>
            )
        },
        {
            title: 'Amount',
            key: 'amount',
            dataIndex: 'amount',
            responsive: ['lg', 'xl', 'md'],
            render: (amount) => (
                <Text default>₱ {formatNumber(amount)}</Text>
            )
        },
        {
            title: 'Action',
            dataIndex: 'action',
            key: 'action',
            render: (text, record) => (
            <Space size={'small'}>
                <Button 
                    type="primary" 
                    ghost 
                    onClick={() => {
                        formEdit.setFieldsValue(record)
                        setSelectedVoter(record)
                        setIsOpenEditForm(true)
                    }}
                >Edit</Button>
                <Modal 
                    title="Edit Amount" 
                    open={isOpenEditForm} 
                    onOk={() => {
                        formEdit.submit()
                        setIsOpenEditForm(false)
                    }}
                    onCancel={() => setIsOpenEditForm(false)}
                >
                    <Form
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={formEdit} 
                        onFinish={onFinishEdit}
                    >
                        <Form.Item 
                            label="Amount" 
                            name="amount"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input Amount.',
                                },
                            ]}
                        >
                            <InputNumber placeholder="Enter Amount" style={{width: "100%"}}/>
                        </Form.Item>
                    </Form>
                </Modal>
                <Button type="primary" ghost danger onClick={() => handleDelete(record.id)}>Delete</Button>
            </Space>
            )
        },
    ];

    const onFinish = (values) => {
        
        const storedData = JSON.parse(localStorage.getItem(`ayudacash_${id}`)) || [];
    
        const updatedList = [...storedData, {id: topUpSelectedVoter.length + 1, ...selectedVoter, ...values}];
    
        setTopUpSelectedVoter(updatedList);

        var total = 0;

        storedData.forEach((topUpSelectedVoter) => {
            total = parseInt(topUpSelectedVoter.amount) + total
        })

        setTotal(total + parseInt(values.amount))

        localStorage.setItem(`ayudacash_${id}`, JSON.stringify(updatedList));
    
        form.resetFields();
    };

    const onFinishEdit = (values) => {
        const storedData = JSON.parse(localStorage.getItem(`ayudacash_${id}`)) || [];

        // Find the previous data
        const previousData = storedData.find(item => item.id === selectedVoter.id);
        const previousAmount = previousData ? parseInt(previousData.amount) : 0; // Handle cases where data doesn't exist

        // Update the voter’s data with new values
        const updatedList = storedData.map(item =>
            item.id === selectedVoter.id
                ? { ...item, ...values } 
                : item 
        );
    
        setTopUpSelectedVoter(updatedList);

        var total = 0;

        // Calculate the new total, but subtract the previous amount first
        storedData.forEach((item) => {
            total += parseInt(item.amount);
        });
        
        // Update the total correctly
        setTotal(total - previousAmount + parseInt(values.amount)); 

        // Save updated data to localStorage
        localStorage.setItem(`ayudacash_${id}`, JSON.stringify(updatedList));
    
        formEdit.resetFields();
        setIsOpenEditForm(false); 
    };

    const handleDelete = (voterId) => {
        const storedData = JSON.parse(localStorage.getItem(`ayudacash_${id}`)) || [];

        // Filter out the voter to delete
        const updatedList = storedData.filter(item => item.id !== voterId);

        // Update the total amount
        const newTotal = updatedList.reduce((sum, item) => sum + parseInt(item.amount), 0);

        // Update state
        setTopUpSelectedVoter(updatedList);
        setTotal(newTotal);

        // Save updated list back to local storage
        localStorage.setItem(`ayudacash_${id}`, JSON.stringify(updatedList));
    };

    const handleTopupVoters = () => {
        const storedData = JSON.parse(localStorage.getItem(`ayudacash_${id}`)) || [];

        if(storedData.length == 0){
            notification.error({
                top: 120,
                message: 'Top Up Error',
                description: 'No Voters selected for Top Up amount.'
            });
            return;
        }

        const transformedData = storedData.map((item) => ({
            votersID: item.ID,
            votersName: item.FullName,
            amount: item.amount, // You can modify this dynamically
            type: 'CASH',
            eventID: eventStore.event.EventID,
            eventName: eventStore.event.EventName,
        }));

        
        if(userStore.teamLeader.amount >= total) {
            eventStore.topupVotersCash(transformedData, id);
        } else{
            notification.error({
                top: 120,
                message: 'Wallet Amount Error!',
                description: 'Not enough balance. Please double-check your current wallet balance before submitting the list of voter amounts.'
            });

            Swal.fire({
                title: "Wallet Amount Error",
                icon: "error",
                text: "Not enough balance. Please double-check your current wallet balance before submitting the list of voter amounts.",
                showCancelButton: false,
                confirmButtonText: "Okay",
                allowOutsideClick: false
            }).then((result) => {
                if (result.isConfirmed) {
                    window.location.reload();
                } 
            })

            return;
        }

    };

    return (
        <div className="admin-add-event-ayuda">
            <Content>
                <div className="admin-add-ayuda-content">
                    <Title level={5}><FilterOutlined /> Filter Voters</Title>
                    <Row gutter={[10, 10]} className="filters">
                        <Col span={8}>
                            <Input
                                placeholder="Enter name"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchName(e.target.value)}
                            />
                        </Col>
                        {hasGender && (
                            <Col span={8}>
                            <Select
                                options={[
                                    { value: 'Male', label: 'Male' },
                                    { value: 'Female', label: 'Female' }
                                ]}
                                placeholder="Select Gender"
                                size="large"
                                onChange={(value) => setSearchGender(value)}
                            />
                            </Col>
                        )}
                        {hasStreet && (
                            <Col span={8}>
                            <Input
                                placeholder="Enter Street"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchStreet(e.target.value)}
                            />
                            </Col>
                        )}
                        {hasAddress && (
                            <Col span={8}>
                            <Input
                                placeholder="Enter Address"
                                allowClear
                                size="large"
                                onChange={(e) => setSearchAddress(e.target.value)}
                            />
                            </Col>
                        )}
                        {hasPWD && (
                            <Col>
                            <Checkbox
                                checked={searchPWD}
                                onChange={(e) => setSearchPWD(e.target.checked)}
                            > Is it a Person with disabilities?</Checkbox>
                            </Col>
                        )}
                    </Row>
                    <Button type="primary" icon={<FilterOutlined />} onClick={handleSearchVoter}>Search Voter</Button>
                    <Collapse className="add-more-filters-collapse">
                        <Panel header={<>Add more filters?</>} style={{width: "100%"}}>
                            <Row gutter={15}>
                                <Col>
                                    <Checkbox 
                                    checked={hasGender}
                                    onChange={() => setHasGender(!hasGender)}
                                    >Gender</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasStreet}
                                    onChange={() => setHasStreet(!hasStreet)}
                                    >Street</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasAddress}
                                    onChange={() => setHasAddress(!hasAddress)}
                                    >Address</Checkbox>
                                </Col>
                                <Col>
                                    <Checkbox 
                                    checked={hasPWD}
                                    onChange={() => setHasPWD(!hasPWD)}
                                    >PWD</Checkbox>
                                </Col>
                            </Row>
                        </Panel>
                    </Collapse>
                    <Divider/>
                    <Table pagination={false} columns={columns} dataSource={cloneDeep(voterStore.voters)} bordered/>
                    <ul className="pagination">
                        <li className="pagination-prev "><Button type="dashed" onClick={handlePrevPage} disabled={voterStore.page == 1 ? true : false}><CaretLeftOutlined />Prev</Button></li>
                        <li className="pagination-item"><a>{voterStore.page}</a></li>
                        <li className="pagination-next "><Button type="dashed" onClick={handleNextPage} disabled={voterStore.hasMore ? false : true}>Next<CaretRightOutlined /></Button></li>
                    </ul>
                </div>
            </Content>
            <Content>
                <Modal 
                    title="Give Ayuda Form" 
                    open={isOpenForm} 
                    onOk={() => {
                        form.submit()
                        setIsOpenForm(false)
                    }}
                    onCancel={() => setIsOpenForm(false)}
                >
                    <Form 
                        name="addbillingInformationForm"
                        layout="vertical"
                        form={form} 
                        onFinish={onFinish}
                    >
                        <Form.Item
                            label="Amount"
                            name="amount"
                            rules={[
                                {
                                    required: true,
                                    message: 'Please input Amount.',
                                },
                            ]}
                        >
                            <InputNumber placeholder="Enter Amount" style={{width: "100%"}}/>
                        </Form.Item>
                        <Divider/>
                    </Form>
                </Modal>
                <div className="admin-add-ayuda-content">
                    <Title level={4}>List of Distributed Amount</Title>
                    <Divider/>
                    <Row justify={'start'}>
                        <Space>
                            <Title level={4} strong>Current Wallet Amount: </Title><Title level={4} strong type="success">₱ {formatNumber(userStore.teamLeader && userStore.teamLeader.amount)}</Title>
                        </Space>
                    </Row>
                    <Table pagination={false} columns={columnsAyuda} dataSource={cloneDeep(topUpSelectedVoter)} bordered/>
                    <Row justify={'end'}>
                        <Space>
                            <Title level={4} strong>Total Top Up Amount: </Title><Title level={4} strong type="danger">₱ {formatNumber(total)}</Title>
                        </Space>
                    </Row>
                    <Divider/>
                    <Row justify={'end'} gutter={12}>
                        <Col>
                            <Button type="primary" htmlType="submit" icon={<PlusOutlined/>} loading={userStore.loading} onClick={handleTopupVoters}>Submit</Button>
                        </Col>
                        <Col>
                            <Button onClick={() => navigate(-1)} loading={userStore.loading}>Back</Button>
                        </Col>
                    </Row>
                </div>
            </Content>
        </div>
    );
};

export default inject('userStore', 'voterStore', 'eventStore')(observer(AddEventAyuda));
